import { Grid } from '@mui/material';

import { useRetrieveOrganization } from '../../../hooks/organization/useRetrieveOrganization';
import { BillingSubscriptionData } from './BillingSubscriptionData';
import { NoSubscriptionPricingTable } from './NoSubscriptionPricingTable';

export const Billing = () => {
  const { data: organization } = useRetrieveOrganization();
  if (!organization) return null;

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      style={{
        backgroundColor: `white`,
        zIndex: 2,
        height: `100%`,
        overflowY: `auto`,
      }}
    >
      {organization.subscription.status !== `active` && organization.subscription.status !== `past_due` ? (
        <NoSubscriptionPricingTable />
      ) : (
        <BillingSubscriptionData />
      )}
    </Grid>
  );
};
